import { SoundButton } from "../../../../common/SoundButton/SoundButton";
import type { ApiCommerceChainJourney } from "@bridge-applications/pb-types";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { haptics } from "../../../../../logic/helpers/haptics";
import coldDrinksLauncher from "../../../../../assets/static/images/commerce/chain-offer/cold-drinks-campaign-launcher.webp";
import { LauncherLabel } from "../LauncherLabel/LauncherLabel";
import "./ChainOfferLauncher.scss";

interface ChainOfferLauncherProps {
    journey: ApiCommerceChainJourney;
    onOpen: () => void;
}

export function ChainOfferLauncher({
    journey,
    onOpen,
}: ChainOfferLauncherProps) {
    const { t } = useTranslation();
    const [now, setNow] = useState(Date.now);

    useEffect(() => {
        const timerId = window.setInterval(() => setNow(Date.now()), 1_000);
        return () => window.clearInterval(timerId);
    }, []);

    if (Date.parse(journey.expiresAt) <= now) return null;

    return (
        <SoundButton
            type="button"
            className="chain-offer-launcher"
            aria-label={t("commerce.chain.launcherAriaLabel")}
            onClick={() => {
                haptics.impact("light");
                onOpen();
            }}
        >
            <img
                className="chain-offer-launcher__art"
                src={coldDrinksLauncher}
                alt=""
                width={607}
                height={597}
                draggable={false}
            />
            <span className="chain-offer-launcher__label">
                <LauncherLabel text={t("commerce.chain.launcherLabel")} />
            </span>
        </SoundButton>
    );
}
